import React, { useState } from "react";
import axios from "axios";
import { MapPin, Phone, MailOpen, Send, Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
import { CONTACT } from "../mock";
import { useToast } from "../hooks/use-toast";
import SwissFlag from "./SwissFlag";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const change = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.message) {
      toast({ title: "Bitte E-Mail und Nachricht ausfüllen.", variant: "destructive" });
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast({
        title: "Nachricht gesendet!",
        description: "Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
      });
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast({
        title: "Senden fehlgeschlagen",
        description: "Bitte versuchen Sie es später erneut oder schreiben Sie uns direkt.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="section-pad bg-white">
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="site-heading text-center max-w-[720px] mx-auto mb-14">
          <h4>Kontakt</h4>
          <h2>{CONTACT.heading}</h2>
          <p>{CONTACT.text}</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Address */}
          <div>
            <div className="swiss-badge dark mb-6">
              <SwissFlag /> Made in Switzerland
            </div>
            <h4 className="text-xl font-semibold mb-6" style={{ color: "#141b34" }}>
              {CONTACT.addressTitle}
            </h4>
            <ul className="space-y-5 mb-9">
              <li className="flex items-start gap-4">
                <span className="contact-icon"><MapPin size={20} /></span>
                <span className="text-slate-600 whitespace-pre-line pt-2">{CONTACT.address}</span>
              </li>
              <li className="flex items-center gap-4">
                <span className="contact-icon"><Phone size={20} /></span>
                <span className="text-slate-600">{CONTACT.phone}</span>
              </li>
              <li className="flex items-center gap-4">
                <span className="contact-icon"><MailOpen size={20} /></span>
                <span className="text-slate-600">{CONTACT.email}</span>
              </li>
            </ul>
            <h4 className="text-lg font-semibold mb-4" style={{ color: "#141b34" }}>Folgen Sie uns</h4>
            <div className="flex gap-3">
              {[Facebook, Twitter, Linkedin, Instagram].map((Ic, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-11 h-11 rounded-full flex items-center justify-center text-white transition-transform hover:-translate-y-1"
                  style={{ background: "linear-gradient(135deg,#1b6ef3,#0b57e0)" }}
                  aria-label="Social"
                >
                  <Ic size={17} />
                </a>
              ))}
            </div>
          </div>

          {/* Form */}
          <div className="bg-white rounded-2xl border border-slate-100 shadow-xl p-8">
            <h3 className="text-2xl font-bold mb-6" style={{ color: "#141b34" }}>
              Erzählen Sie uns von Ihrer Idee
            </h3>
            <form onSubmit={submit} className="space-y-4">
              <input className="field" name="name" placeholder="Name" value={form.name} onChange={change} />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input className="field" name="email" type="email" placeholder="E-Mail *" value={form.email} onChange={change} />
                <input className="field" name="phone" placeholder="Telefon" value={form.phone} onChange={change} />
              </div>
              <textarea className="field min-h-[130px] resize-none" name="message" placeholder="Erzählen Sie uns von Ihrem Projekt *" value={form.message} onChange={change} />
              <button type="submit" className="btn-theme w-full justify-center" disabled={loading}>
                {loading ? "Wird gesendet..." : "Nachricht senden"} <Send size={17} />
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
